var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Active Backlog","chart":"column","chartType":"backlog","isCity":false,"withDate":false,"withFinancial":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }